// extracted by mini-css-extract-plugin
export default {"section":"TimeLogsRulesModal_section__BwOV4","sectionTitle":"TimeLogsRulesModal_sectionTitle__lVwbO","list":"TimeLogsRulesModal_list__yuWQm"};